const TRUST_BADGES = [
  "✓ NABP Accredited",
  "✓ Free Software",
  "✓ Credential review required",
] as const;

interface TrustBadgesProps {
  /** "dark" = on a dark/colored background (white pill style).
   *  "light" = on a white/light background (gray pill style). */
  variant?: "dark" | "light";
  className?: string;
  signals?: string[];
}

/**
 * TrustBadges — shared micro-badges used in both the hero and the
 * "How It Works" section CTA block.
 */
export default function TrustBadges({
  variant = "dark",
  className = "",
  signals,
}: TrustBadgesProps) {
  const pillClass =
    variant === "dark"
      ? "bg-white/10 border border-white/20 text-white/90"
      : "bg-gray-100 border border-gray-200 text-gray-600";

  return (
    <div className={`flex flex-wrap justify-center gap-3 ${className}`}>
      {(signals?.length ? signals : TRUST_BADGES).map((badge) => (
        <span
          key={badge}
          className={`inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-full ${pillClass}`}
        >
          {badge}
        </span>
      ))}
    </div>
  );
}
